"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowVersionstateEnumType = exports.ReturnItemState = exports.PricingAdjustmentStagingItemvalidationStatusEnumType = exports.OmitMeasurementsOptionPrivate = exports.OmitMeasurementsOptionAdmin = exports.ImageUrlsFieldType = exports.ImageOptionsPresetType = exports.IbanSensitiveDetailsFieldAdmin = exports.ColorHueEnumTypeAdmin = exports.CatalogItemMeasurementFieldPurposeRestUser = exports.CatalogItemMeasurementFieldPurposePublic = exports.CatalogItemMeasurementFieldPurposePrivate = exports.CatalogItemMeasurementFieldPurposeAdmin = exports.BooleanFieldOptions = void 0;
var BooleanFieldOptions;
(function (BooleanFieldOptions) {
    BooleanFieldOptions["All"] = "ALL";
    BooleanFieldOptions["No"] = "NO";
    BooleanFieldOptions["Yes"] = "YES";
})(BooleanFieldOptions || (exports.BooleanFieldOptions = BooleanFieldOptions = {}));
var CatalogItemMeasurementFieldPurposeAdmin;
(function (CatalogItemMeasurementFieldPurposeAdmin) {
    /** Load all measurement fields configured for use by check-in associates when checking in new instances of this catalog item. */
    CatalogItemMeasurementFieldPurposeAdmin["Checkin"] = "CHECKIN";
    /** Load all configured measurement fields for this catalog item. */
    CatalogItemMeasurementFieldPurposeAdmin["General"] = "GENERAL";
    /** Load all measurement fields for this catalog item that are configured for display to customers. */
    CatalogItemMeasurementFieldPurposeAdmin["Shop"] = "SHOP";
})(CatalogItemMeasurementFieldPurposeAdmin || (exports.CatalogItemMeasurementFieldPurposeAdmin = CatalogItemMeasurementFieldPurposeAdmin = {}));
var CatalogItemMeasurementFieldPurposePrivate;
(function (CatalogItemMeasurementFieldPurposePrivate) {
    /** Load all measurement fields configured for use by check-in associates when checking in new instances of this catalog item. */
    CatalogItemMeasurementFieldPurposePrivate["Checkin"] = "CHECKIN";
    /** Load all configured measurement fields for this catalog item. */
    CatalogItemMeasurementFieldPurposePrivate["General"] = "GENERAL";
    /** Load all measurement fields for this catalog item that are configured for display to customers. */
    CatalogItemMeasurementFieldPurposePrivate["Shop"] = "SHOP";
})(CatalogItemMeasurementFieldPurposePrivate || (exports.CatalogItemMeasurementFieldPurposePrivate = CatalogItemMeasurementFieldPurposePrivate = {}));
var CatalogItemMeasurementFieldPurposePublic;
(function (CatalogItemMeasurementFieldPurposePublic) {
    /** Load all measurement fields configured for use by check-in associates when checking in new instances of this catalog item. */
    CatalogItemMeasurementFieldPurposePublic["Checkin"] = "CHECKIN";
    /** Load all configured measurement fields for this catalog item. */
    CatalogItemMeasurementFieldPurposePublic["General"] = "GENERAL";
    /** Load all measurement fields for this catalog item that are configured for display to customers. */
    CatalogItemMeasurementFieldPurposePublic["Shop"] = "SHOP";
})(CatalogItemMeasurementFieldPurposePublic || (exports.CatalogItemMeasurementFieldPurposePublic = CatalogItemMeasurementFieldPurposePublic = {}));
var CatalogItemMeasurementFieldPurposeRestUser;
(function (CatalogItemMeasurementFieldPurposeRestUser) {
    /** Load all measurement fields configured for use by check-in associates when checking in new instances of this catalog item. */
    CatalogItemMeasurementFieldPurposeRestUser["Checkin"] = "CHECKIN";
    /** Load all configured measurement fields for this catalog item. */
    CatalogItemMeasurementFieldPurposeRestUser["General"] = "GENERAL";
    /** Load all measurement fields for this catalog item that are configured for display to customers. */
    CatalogItemMeasurementFieldPurposeRestUser["Shop"] = "SHOP";
})(CatalogItemMeasurementFieldPurposeRestUser || (exports.CatalogItemMeasurementFieldPurposeRestUser = CatalogItemMeasurementFieldPurposeRestUser = {}));
var ColorHueEnumTypeAdmin;
(function (ColorHueEnumTypeAdmin) {
    ColorHueEnumTypeAdmin["BluePurple"] = "BLUE_PURPLE";
    ColorHueEnumTypeAdmin["GreenYellow"] = "GREEN_YELLOW";
    ColorHueEnumTypeAdmin["Neutral"] = "NEUTRAL";
    ColorHueEnumTypeAdmin["Other"] = "OTHER";
    ColorHueEnumTypeAdmin["RedOrange"] = "RED_ORANGE";
})(ColorHueEnumTypeAdmin || (exports.ColorHueEnumTypeAdmin = ColorHueEnumTypeAdmin = {}));
/** Fields available for sensitive IBAN data access */
var IbanSensitiveDetailsFieldAdmin;
(function (IbanSensitiveDetailsFieldAdmin) {
    /** Full unmasked IBAN number (requires authorization) */
    IbanSensitiveDetailsFieldAdmin["Iban"] = "IBAN";
})(IbanSensitiveDetailsFieldAdmin || (exports.IbanSensitiveDetailsFieldAdmin = IbanSensitiveDetailsFieldAdmin = {}));
var ImageOptionsPresetType;
(function (ImageOptionsPresetType) {
    ImageOptionsPresetType["Large"] = "LARGE";
    ImageOptionsPresetType["Medium"] = "MEDIUM";
    ImageOptionsPresetType["Small"] = "SMALL";
    ImageOptionsPresetType["Thumbnail"] = "THUMBNAIL";
})(ImageOptionsPresetType || (exports.ImageOptionsPresetType = ImageOptionsPresetType = {}));
var ImageUrlsFieldType;
(function (ImageUrlsFieldType) {
    ImageUrlsFieldType["ImageUrls"] = "image_urls";
    ImageUrlsFieldType["SendbackImageUrls"] = "sendback_image_urls";
})(ImageUrlsFieldType || (exports.ImageUrlsFieldType = ImageUrlsFieldType = {}));
var OmitMeasurementsOptionAdmin;
(function (OmitMeasurementsOptionAdmin) {
    /** Omit any auto-generated measurements text from the condition notes whether or not structured measurements collection is enabled for check-in. */
    OmitMeasurementsOptionAdmin["Always"] = "ALWAYS";
    /** Return the notes including any measurements text generated automatically at check-in time. */
    OmitMeasurementsOptionAdmin["Never"] = "NEVER";
    /** Omit any auto-generated measurements text from the condition notes provided structured measurements collection is enabled for check-in. */
    OmitMeasurementsOptionAdmin["WhenMeasurementsEnabledForCheckin"] = "WHEN_MEASUREMENTS_ENABLED_FOR_CHECKIN";
})(OmitMeasurementsOptionAdmin || (exports.OmitMeasurementsOptionAdmin = OmitMeasurementsOptionAdmin = {}));
var OmitMeasurementsOptionPrivate;
(function (OmitMeasurementsOptionPrivate) {
    /** Omit any auto-generated measurements text from the condition notes whether or not structured measurements collection is enabled for check-in. */
    OmitMeasurementsOptionPrivate["Always"] = "ALWAYS";
    /** Return the notes including any measurements text generated automatically at check-in time. */
    OmitMeasurementsOptionPrivate["Never"] = "NEVER";
    /** Omit any auto-generated measurements text from the condition notes provided structured measurements collection is enabled for check-in. */
    OmitMeasurementsOptionPrivate["WhenMeasurementsEnabledForCheckin"] = "WHEN_MEASUREMENTS_ENABLED_FOR_CHECKIN";
})(OmitMeasurementsOptionPrivate || (exports.OmitMeasurementsOptionPrivate = OmitMeasurementsOptionPrivate = {}));
var PricingAdjustmentStagingItemvalidationStatusEnumType;
(function (PricingAdjustmentStagingItemvalidationStatusEnumType) {
    PricingAdjustmentStagingItemvalidationStatusEnumType["Error"] = "error";
    PricingAdjustmentStagingItemvalidationStatusEnumType["Valid"] = "valid";
    PricingAdjustmentStagingItemvalidationStatusEnumType["Warning"] = "warning";
})(PricingAdjustmentStagingItemvalidationStatusEnumType || (exports.PricingAdjustmentStagingItemvalidationStatusEnumType = PricingAdjustmentStagingItemvalidationStatusEnumType = {}));
var ReturnItemState;
(function (ReturnItemState) {
    ReturnItemState["Deleted"] = "DELETED";
    ReturnItemState["Expected"] = "EXPECTED";
    ReturnItemState["ExtraItem"] = "EXTRA_ITEM";
    ReturnItemState["Missing"] = "MISSING";
    ReturnItemState["Processed"] = "PROCESSED";
})(ReturnItemState || (exports.ReturnItemState = ReturnItemState = {}));
var WorkflowVersionstateEnumType;
(function (WorkflowVersionstateEnumType) {
    WorkflowVersionstateEnumType["Active"] = "ACTIVE";
    WorkflowVersionstateEnumType["Archived"] = "ARCHIVED";
    WorkflowVersionstateEnumType["Draft"] = "DRAFT";
})(WorkflowVersionstateEnumType || (exports.WorkflowVersionstateEnumType = WorkflowVersionstateEnumType = {}));
//# sourceMappingURL=rewareAdminTypes.js.map